module.exports = require("./dist/angular-file-upload.min.js");


//////////////////
// WEBPACK FOOTER
// angular-file-upload (bower component)
// module id = 1397
// module chunks = 0